import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';

import { TableToolbar } from './TableToolbar.js';
import {
    useDataGridStyles,
    formatTime,
    MAX_ROWS,
    dateComparator,
} from './datagridutil';

function MemberTable(props) {
    const { members, onSelectUser, onEditMember, onRemoveMember, single } =
        props;
    const classes = useDataGridStyles();

    if (!(members?.length > 0)) {
        return null;
    }

    const renderEdit = (params) => {
        return (
            <Tooltip title={''}>
                <span>
                    <IconButton
                        key="edit"
                        aria-label="Edit"
                        color="inherit"
                        onClick={(event) => {
                            onEditMember && onEditMember(params.value);
                            event.stopPropagation();
                        }}
                        size="large"
                    >
                        <Icon>edit</Icon>
                    </IconButton>
                </span>
            </Tooltip>
        );
    };

    const renderRemove = (params) => {
        return (
            <Tooltip title={''}>
                <span>
                    <IconButton
                        key="remove"
                        aria-label="Remove"
                        color="inherit"
                        onClick={(event) => {
                            onRemoveMember && onRemoveMember(params.value);
                            event.stopPropagation();
                        }}
                        size="large"
                    >
                        <Icon>delete</Icon>
                    </IconButton>
                </span>
            </Tooltip>
        );
    };

    const autoHeight = single || members.length <= MAX_ROWS;

    const columns = [
        { field: 'role', headerName: 'Role', flex: 0.5 },
        {
            field: 'User',
            headerName: 'User',
            flex: 1,
            valueGetter: (params) => params.row.User?.email || '',
        },
        { field: 'inviteEmail', headerName: 'Invite', flex: 1 },
        {
            field: 'createdAt',
            headerName: 'Created',
            width: 100,
            valueGetter: formatTime,
            sortComparator: dateComparator,
        },
        {
            field: 'updatedAt',
            headerName: 'Updated',
            width: 100,
            valueGetter: formatTime,
            sortComparator: dateComparator,
        },
        {
            field: 'edit',
            headerName: '',
            width: 58,
            renderCell: renderEdit,
            valueGetter: (params) => params.row.id,
            disableExport: true,
        },
        {
            field: 'remove',
            headerName: '',
            width: 58,
            renderCell: renderRemove,
            valueGetter: (params) => params.row.id,
            disableExport: true,
        },
    ];

    if (single) {
        columns.splice(1, 2);
    }

    return (
        <Paper
            className={classes.root}
            sx={{ height: autoHeight ? undefined : 93 + MAX_ROWS * 36 }}
        >
            <DataGrid
                slots={{ toolbar: TableToolbar }}
                slotProps={{ toolbar: { csvFileName: 'cc-members' } }}
                autoHeight={autoHeight}
                rows={members}
                columns={columns}
                hideFooter={autoHeight}
                hideFooterSelectedRowCount
                isRowSelectable={() => false}
                onRowClick={(params) =>
                    onSelectUser && onSelectUser(params.row.User.id)
                }
                className={
                    autoHeight ? classes.dataGridAutoHeight : classes.dataGrid
                }
                density="compact"
                sx={
                    single
                        ? {}
                        : {
                              '& .MuiDataGrid-row:hover': {
                                  cursor: 'pointer',
                              },
                          }
                }
            />
        </Paper>
    );
}

export default MemberTable;
